/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import { ComponentSurveyAnswers, QuestionEntity } from '@/graphql/generated/graphql';
import { useAuthentication } from '@/hooks/useAuthentication';
import { AnswerProps } from '../useDailyAnswer';

export const Question = ({
  question,
  setSelectedAnswer,
  index,
}: {
  question: QuestionEntity;
  setSelectedAnswer: (answer: AnswerProps) => void;
  index: number;
}) => {
  const scale = question?.attributes?.scale?.data?.attributes?.options || [];
  const { authentication } = useAuthentication();

  const renderCard = () => {
    return (
      <>
        <p className="mb-sh-15 line-clamp-2 h-8 min-h-[36px] text-center text-sh-xxxs font-bold">
          Question {index + 1}: <span className="font-normal">{question.attributes?.question}</span>
        </p>

        <div className="flex w-full max-w-[250px] flex-col overflow-hidden rounded-2xl border border-[#A1C3EC] text-center">
          {scale.map((item) => (
            <div
              onClick={() => {
                setSelectedAnswer({
                  currentQuestion: question,
                  option: item as ComponentSurveyAnswers,
                  user: authentication.user,
                });
              }}
              key={item?.option}
              className={classNames(
                'flex w-full cursor-pointer items-center justify-center border-b border-[#A1C3EC] bg-primary-100 px-2 py-[17px] last-of-type:border-none hover:bg-primary-500 hover:font-bold md:px-sh-15 ',
              )}>
              <p className="!m-0 text-sh-11-14 font-bold">{item?.option}</p>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <div className="mb-4 flex min-h-[173px] w-[366px] flex-col items-center rounded-2xl border border-[#A1C3EC] bg-white p-sh-30 md:mb-0 md:w-[415px]">
      {renderCard()}
    </div>
  );
};
